import Link from "@/components/Link";

import styles from "./styles.module.scss";
import { List as MantineList, Text as MantineText } from "@mantine/core";

const Breadcrumb = ({ items, className = "" }) => {
  return (
    <nav className={`${styles.breadcrumb} ${className}`.trim()}>
      <MantineList type="ordered">
        {items.map((item, index) => (
          <MantineList.Item key={index}>
            {item.link ? <Link href={item.link}>{item.text}</Link> : item.text}
            {index < items.length - 1 && <MantineText span>&nbsp;&gt;&nbsp;</MantineText>}
          </MantineList.Item>
        ))}
      </MantineList>
    </nav>
  );
};

export default Breadcrumb;
